import './Spinner.scss';
import classnames from 'classnames';
import type { FC } from 'react';

/**
 * @description Props for the Spinner component
 */
type SpinnerProps = {
  /** Type of loader to display ('loader' or 'loader-circle') */
  loader?: 'loader' | 'loader-circle';
  /** Whether the spinner should be white */
  isWhite?: boolean;
  /** Whether the spinner should be small */
  isSmall?: boolean;
  /** Whether the spinner should be hidden */
  isHidden?: boolean;
  /** Whether the spinner should be positioned absolutely */
  isAbsolute?: boolean;
};

/**
 * @description Spinner component for indicating loading states.
 * Provides customizable loading indicators with different styles and positioning options.
 *
 * @SADtrace SAD-003-1.1, SAD-003-2.1, SAD-003-3.1, SAD-003-4.1, SAD-003-5.1, SAD-003-6.1
 *
 * @History
 * 04-18-2025 aleksandar dukleski: DLA-1364 added function headers
 * 11-05-2025 aleksandar dukleski: DLA-1428 added history tag to function headers
 *
 * @param {SpinnerProps} props - The component props
 *
 * @returns {JSX.Element} A spinner element
 */
const Spinner: FC<SpinnerProps> = ({
  isAbsolute,
  isHidden,
  isSmall,
  isWhite,
  loader = 'loader',
}) => {
  const classNames = classnames({
    loader,
    white: isWhite,
    small: isSmall,
    hidden: isHidden,
    absolute: isAbsolute,
  });

  return (
    <div className={classNames} data-testid="spinner">
      Loading
    </div>
  );
};

export default Spinner;
